import { useEffect, useState } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Navigation from './components/layout/Navigation'
import Footer from './components/layout/Footer'
import Hero from './components/sections/Hero'
import About from './components/sections/About'
import Projects from './components/sections/Projects'
import Contact from './components/sections/Contact'
import Resume from './components/sections/Resume'
import PaymentSuccess from './pages/PaymentSuccess'
import ClientPortal from './pages/ClientPortal'
import MagneticCursor from './components/animations/MagneticCursor'
import FloatingShapes from './components/animations/FloatingShapes'
import Dashboard from './components/dashboard/Dashboard'
import DashboardLogin from './components/dashboard/DashboardLogin'
import { AuthProvider } from './contexts/AuthContext'
import { ThemeProvider } from './contexts/ThemeContext'
import ProtectedRoute from './components/dashboard/ProtectedRoute'
import ThemeToggle from './components/layout/ThemeToggle'
import InteractiveTerminal from './components/animations/InteractiveTerminal'

function App() {
  const [showCursor, setShowCursor] = useState(false)

  useEffect(() => {
    // Prevent flash of unstyled content
    document.body.classList.add('loaded')
    
    // Show cursor only on desktop
    if (window.matchMedia('(pointer: fine)').matches) {
      setShowCursor(true)
    }
  }, [])

  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-background relative">
            <ThemeToggle />
            <InteractiveTerminal />
            <FloatingShapes />
            {showCursor && <MagneticCursor />}
          <Routes>
            {/* Public Routes */}
            <Route
              path="/"
              element={
                <>
                  <Navigation />
                  <main>
                    <Hero />
                    <About />
                    <Projects />
                    <Resume />
                    <Contact />
                    <Footer />
                  </main>
                </>
              }
            />
            <Route
              path="/services/payment-success"
              element={
                <>
                  <Navigation />
                  <main>
                    <PaymentSuccess />
                    <Footer />
                  </main>
                </>
              }
            />
            <Route
              path="/portal"
              element={
                <>
                  <Navigation />
                  <main>
                    <ClientPortal />
                    <Footer />
                  </main>
                </>
              }
            />
            
            {/* Dashboard Routes */}
            <Route path="/dashboard/login" element={<DashboardLogin />} />
            <Route
              path="/dashboard/*"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            
            {/* Catch all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </div>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App
